import React from "react";
import {
  StyledToastContainer,
  ToastIconContainer,
  ToastIcon,
  ToastButton,
} from "./Toast.styles";
import { ToastProps } from "./Toast.types";
import { Body5MediumTypography } from "../../primitives/Typography/typographyVariants";
import { colorPalette } from "../../theme/colors";

export const Toast: React.FC<ToastProps> = ({
  message,
  type = "neutral",
  action = "none",
  actionLabel,
  onClick, // Handles all actions
  icon, // Custom icon class
}) => {
  return (
    <StyledToastContainer action={action} type={type} onClick={onClick}>
      {action === "icon" && (
        <ToastIconContainer onClick={onClick}>
          <ToastIcon className={icon || "fa-solid fa-thumbs-up"}></ToastIcon>
        </ToastIconContainer>
      )}

      <Body5MediumTypography color={colorPalette.popWhite[500]}>
        {message}
      </Body5MediumTypography>

      {action === "link" && (
        <ToastButton onClick={onClick} toastType={type}>
          <Body5MediumTypography>{actionLabel}</Body5MediumTypography>
        </ToastButton>
      )}

      {action === "dismissable" && (
        <ToastIconContainer onClick={onClick}>
          <ToastIcon className="fa-solid fa-circle-xmark"></ToastIcon>
        </ToastIconContainer>
      )}
    </StyledToastContainer>
  );
};
